module.exports = __webpack_public_path__ + "img/283-23b491.png";